import React from 'react';
import { StatusTip } from 'tea-component';

import './index.scss';
import { getLocale } from 'umi';

export default function LoadingCommon({
  loadingText,
  loadingExt,
  isFullPage,
  ...props
}: any) {
  const locale = getLocale();

  return (
    <div className={`loading-common ${isFullPage ? 'dbo-full-page' : ''}`}>
      <StatusTip
        loadingText={
          loadingText || (locale === 'en-US' ? 'Loading...' : '加载中...')
        }
        {...props}
      />
      {loadingExt}
    </div>
  );
}
